var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadGeneration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.64551H5.81191C5.81191 7.85477 5.91851 10.0242 5.78948 12.1936C5.52581 16.541 8.83569 19.1118 11.8202 19.0976C15.5143 19.0805 18.1622 16.2164 18.1819 12.1224C18.1819 10.0043 18.1819 7.88325 18.1819 5.68822H23.9405C23.7666 9.86761 24.6586 14.0954 22.74 18.0926C21.5363 20.582 19.5405 22.5865 17.0754 23.782C14.6102 24.9775 11.8198 25.2941 9.15546 24.6805C3.826 23.4705 0.0364647 18.6022 0 12.8996C0 10.5224 0 8.16225 0 5.64551Z",
    fill: "#2965FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75254 3.49586H0.142578V0.0253906H5.75254V3.49586Z",
    fill: "#2965FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2305 3.44201V0H23.7955V3.44201H18.2305Z",
    fill: "#2965FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadGeneration);
export default __webpack_public_path__ + "static/media/lead-generation.4c0253d5079af868a6524c8dab06edd3.svg";
export { ForwardRef as ReactComponent };